import * as rtk from '@reduxjs/toolkit';
// @ts-expect-error ESM/CJS compatibility for `@reduxjs/toolkit`
const { createAction, createSlice } = ({ ...rtk }.default || rtk);
export const hostStateName = 'host';
const hostSlice = createSlice({
    name: hostStateName,
    initialState: {
        appId: undefined,
        appVersion: undefined,
        context: {},
    },
    reducers: {},
    extraReducers(builder) {
        builder.addCase(setHostInfoAction, (state, { payload }) => {
            state.appId = payload.appId;
            state.appVersion = payload.appVersion;
            state.context = payload.context;
        });
    },
});
export const setHostInfoAction = createAction('crystal/setHostInfo');
export const { reducer: hostReducer } = hostSlice;
//# sourceMappingURL=host.js.map